import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=1a84ef9f&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a84ef9f')) {
      api.createRecord('1a84ef9f', component.options)
    } else {
      api.reload('1a84ef9f', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=1a84ef9f&", function () {
      api.rerender('1a84ef9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ItzJVaOR4L5i/JS/comp/FavElement.vue"
export default component.exports